import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { getAppStoreApi } from "@/src/redux/storeClient";

export function ReduxProvider({ children }: { children: React.ReactNode }) {
  const { store, persistor } = getAppStoreApi();

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        {children}
      </PersistGate>
    </Provider>
  );
}
